import styled from 'styled-components';
import AppCSS from '../../utils/styled';
import { UIView } from '../../utils/styled/styled';

export const Components = {
  Container: styled(UIView)``,

  InsightsHeader: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 12px;
    ${AppCSS.radiuses.small};
    background-color: ${AppCSS.colors.blues.veryLight};
    ${AppCSS.boxShadows.block};
    padding: 12px;
    margin: 6px 0;
  `,
  InsightsTitle: styled.span`
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.blues.strong};
  `,
  InsightsItemWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
  `,
  InsightsItem: styled.span`
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.blues.strong};
    width: auto;
  `,
  InsightsBullet: styled.span`
    height: 6px;
    width: 6px;
    background-color: ${AppCSS.colors.blues.strong};
    border-radius: 50%;
  `,

  InsightsCard: styled.span`
    width: auto;
    justify-content: center;
    align-items: center;
    display: flex;
    ${AppCSS.radiuses.small};
    background-color: ${AppCSS.colors.blues.veryLight};
    padding: 12px;
    gap: 6px;
  `,

  IconWrapper: styled.span`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 12px;
    max-height: 12px;
    width: 12px;
    max-width: 12px;
  `,
};
